export const PROPERTY_GUEST_GUIDE_OPEN_EVENT = 'inspire:open-property-guest-guide';

export function openPropertyGuestGuide() {
  window.dispatchEvent(new Event(PROPERTY_GUEST_GUIDE_OPEN_EVENT));
}
